module.exports = __webpack_public_path__ + "img/frontdoor-m.639d18ca.jpg";